import { Vector2 } from "three";
import { Arrays } from "../../tools/Arrays";
import { ButtonInfo } from "./ButtonInfo";

export class PointerInfo
{
  protected _id:string;
  get id():string { return this._id }

  position:Vector2 = new Vector2();
  positionBefore:Vector2 = new Vector2();
  positionNext:Vector2 = new Vector2();

  buttons:ButtonInfo[] = [];

  update()
  {
    this.positionBefore.copy( this.position );
    this.position.copy( this.positionNext );
    
    this.buttons.forEach( b => b.update() );
  }

  static createMouseInfo()
  {
    let info = new PointerInfo();
    info._id = "mouse";
        
    for ( let i = 0; i < 3; i++ )
    {
      let buttonInfo = ButtonInfo.create( i + "" );
      info.buttons.push( buttonInfo );
    }

    return info;
  }
  
}